<template>
  <div class="foot">
    <el-row :gutter="10" class="footTable">
      <el-col :xs="10" :sm="10" :md="4">
        <p>{{ $t("关于誉诚") }}</p>
        <br />
        <div @click="changeURL('/Introduction')">{{ $t("誉诚简介") }}</div>
        <br />
        <div @click="changeURL('/Branch')">{{ $t("分子公司") }}</div>
        <br />
        <div @click="changeURL('/development')">{{ $t("发展历程") }}</div>
        <br />
        <div @click="changeURL('/certificate')">{{ $t("资质证书") }}</div>
      </el-col>
      <el-col :xs="10" :sm="10" :md="4">
        <p>{{ $t("关于业务") }}</p>
        <br />
        <div @click="changeURL('/domestic')">{{ $t("国内业务") }}</div>
        <br />
        <div @click="changeURL('/International')">{{ $t("国际业务") }}</div>
      </el-col>
      <el-col :xs="10" :sm="10" :md="4">
        <p>{{ $t("产品中心") }}</p>
        <br />
        <div @click="turnClass(1)">{{ $t("一次性防护服") }}</div>
        <br />
        <div @click="turnClass(2)">{{ $t("实验服") }}</div>
        <br />
        <div @click="turnPro(3, 13)">{{ $t("隔离衣") }}</div>
        <br />
        <div @click="turnPro(4, 15)">{{ $t("一次性防护口罩") }}</div>
        <br />
        <div @click="turnClass(5)">{{ $t("透气膜头套") }}</div>
        <br />
        <div @click="turnPro(6, 18)">{{ $t("胡须套") }}</div>
        <br />
        <div @click="turnPro(7, 19)">{{ $t("条帽") }}</div>
        <br />
        <div @click="turnClass(8)">{{ $t("袖套") }}</div>
        <br />
        <div @click="turnClass(9)">{{ $t("靴套") }}</div>
        <br />
        <div @click="turnClass(10)">{{ $t("鞋套") }}</div>
        <br />
        <div @click="turnPro(11, 29)">{{ $t("PE塑料手套") }}</div>
      </el-col>
      <el-col :xs="10" :sm="10" :md="4">
        <p>{{ $t("新闻中心") }}</p>
        <br />
        <div @click="changeURL('/news')">{{ $t("新闻动态") }}</div>
        <br />
        <div @click="changeURL('/videoCenter')">{{ $t("视频中心") }}</div>
      </el-col>
      <el-col :xs="10" :sm="10" :md="4">
        <p>{{ $t("联系我们") }}</p>
        <br />
        <div @click="changeURL('/contact')">{{ $t("联系方式") }}</div>
        <br />
        <div @click="oepnWin()">{{ $t("誉诚商城") }}</div>
      </el-col>
      <!-- <el-col :xs="4" :sm="4" :md="4" class="footlogo"> -->
      <div class="footlogo">
        <img class="log" src="../../public/img/footLogo.png" alt="" srcset="" />
        <div class="Line"></div>
        <div class="logo_box">
          <div class="logo_box_left">
            <img
              src="../../public/img/09m/home/电话.png"
              width="100%"
              alt=""
              srcset=""
            />
          </div>
          <div class="logo_box_right">
            <div>TELEPHONE</div>
            <div>+86 18682253810</div>
          </div>
        </div>
        <div class="logo_box">
          <div class="logo_box_left">
            <img
              src="../../public/img/09m/home/邮箱.png"
              width="100%"
              alt=""
              srcset=""
            />
          </div>
          <div class="logo_box_right">
            <div>EMAIL</div>
            <div>zhushuo@xiantaoyucheng.com</div>
          </div>
        </div>
        <div class="logo_box">
          <div class="logo_box_left">
            <img
              src="../../public/img/09m/home/位置图标.png"
              width="100%"
              alt=""
              srcset=""
            />
          </div>
          <div class="logo_box_right">
            <div>ADDRESS</div>
            <div style="white-space:nowrap;">
              中国湖北省仙桃市彭场镇新民路51-11
            </div>
          </div>
        </div>
      </div>
      <!-- </el-col> -->
    </el-row>
    <div class="lines"></div>
    <div class="foot_bottom">
      <div @click="openBA()">{{ $t("网站备案") }}鄂ICP备20002610号-1</div>
      <a
        class="police"
        href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010102002019&token=fcb67097-e72d-4b8f-90e1-8fca416b2faf"
      >
        <img
          style="marginRight: 8px"
          src="http://www.beian.gov.cn/file/ghs.png"
        />
        <div>鄂公网安备 42900402000453号</div>
      </a>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    changeURL(url) {
      this.$router.push(url)
    },
    oepnWin() {
      window.open(
        "https://yuchengfanghu.1688.com/?spm=a2615.7691456.autotrace-topNav.1.39136f9d1kMxcX",
        "blank"
      )
    },
    openBA() {
      window.open("https://beian.miit.gov.cn", "blank")
    },
    turnClass(id) {
      this.$router.push({
        path: "/productClass_info_class", //这个path就是你在router/index.js里边配置的路径
        query: {
          classId: id,
        },
      })
      // this.$router.go(0)
    },
    turnPro(cid, pid) {
      this.$router.push({
        path: "/productClass_info", //这个path就是你在router/index.js里边配置的路径
        query: {
          classId: cid,
          productId: pid,
        },
      })

      //
    },
  },
}
</script>
<style lang="less" scope>
.police {
  display: flex;
  align-items: center;
  text-decoration: none;
  color: white;
}
.foot {
  cursor: pointer;
  width: 100vw;
  // min-height: 200px;
  background-color: #017ca4;
  display: flex;
  padding-top: 2vh;
  justify-content: center;
  position: relative;
  overflow: hidden;
  padding-bottom: 15vh;
  background-image: linear-gradient(
    45deg,
    rgba(0, 124, 169, 1) 50%,
    rgba(0, 157, 64, 1)
  );
  .foot_bottom {
    position: absolute;
    bottom: 5%;
    left: 20%;
    font-size: 0.6rem;
    color: #fff;
  }
}
.Line {
  width: 200px;
  height: 1px;
  background-color: #fff;
  margin-top: 20px;
}
.lines {
  position: absolute;
  left: 20%;
  bottom: 11%;
  width: 60%;
  height: 1px;
  background-color: #fff;
  // transform: translateX(-50%);
}
.logo_box {
  width: 100%;
  // min-height: 20px;
  margin-top: 10px;
  display: flex;
  // justify-content: space-between;
  align-items: center;
  // background-color: red;
  height: 50px;
  .logo_box_left {
    width: 25px;
    // background-color: #017CA4;
    flex-shrink: 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .logo_box_right {
    margin-left: 10px;
    display: flex;
    // background-color: green;
    flex-direction: column;
    color: #fff;
    flex-shrink: 1;
    font-size: 0.6rem;
  }
}
.footTable {
  width: 60vw;
  margin: 0 auto;
  display: block;
  position: relative;
  .el-col {
    font-size: 0.6rem;
    color: #fff;
    margin-top: 2rem;
    // height: 100%;
    @media (max-width: 1024px) {
      p {
        font-size: 1rem;
      }
    }
    @media (min-width: 1024px) {
      p {
        font-size: 0.8rem;
      }
    }
  }
  .footlogo {
    position: absolute;
    right: 0%;
    transform: translate(80%, 20%);
    // background-color: red;
    .log {
      width: 7rem;
    }
    // display: flex;
    // flex-direction: column;
    // align-items: center;
    // justify-content: center;
    // height: 7rem;
    // @media (max-width: 1024px) {
    //     img{
    //         width:7rem;
    //     }
    // }
    // @media (min-width: 1024px) {
    //     img{
    //         width:100%;
    //     }
    // }
  }
}
</style>
<i18n>
{
  "en": {
     "关于誉诚":"About Yucheng",
     "誉诚简介":"Introduction Yucheng",       
     "分子公司":"Branch",       
     "发展历程":"Development Path",       
     "资质证书":"Certifications",       
     "关于业务":"About Business",       
     "国内业务":"Domestic Business",       
     "国际业务":"International Business",       
     "产品中心":"Product Center",       
     "医疗防护":"Medical Protection",       
     "日常防护":"Daily Protection",       
     "新闻中心":"News Center",       
     "新闻动态":"News",       
     "视频中心":"Video Center",       
     "联系我们":"Contact Us",       
     "联系方式":"Contact Information",       
     "誉诚商城":"Yucheng Mall",
     "网站备案":"Website Registration / License Number:",  
      "一次性防护服":"Disposable Coverall",
       "实验服":"Disposable Lab Coat",
       "隔离衣":"Disposable Isolation Gown",
       "一次性防护口罩":"Disposable Face Mask",
       "透气膜头套":"Microporous Hood",
       "胡须套":"Beard Cover",
       "条帽":"Bouffant Cap",    
       "袖套":"Microporous Sleeve Cover",       
       "靴套":"Disposable Boot Cover",       
       "鞋套":"Shoe Cover",
       "PE塑料手套":"Plastic Gloves"
  },
  "zh": {
     "关于誉诚":"关于誉诚",
     "誉诚简介":"誉诚简介",       
     "分子公司":"分子公司",       
     "发展历程":"发展历程",       
     "资质证书":"资质证书",       
     "关于业务":"关于业务",       
     "国内业务":"国内业务",       
     "国际业务":"国际业务",       
     "产品中心":"产品中心",       
     "医疗防护":"医疗防护",       
     "日常防护":"日常护理",       
     "新闻中心":"新闻中心",       
     "新闻动态":"新闻动态",       
     "视频中心":"视频中心",       
     "联系我们":"联系我们",       
     "联系方式":"联系方式",       
     "誉诚商城":"誉诚商城",
     "网站备案":"网站备案/许可证号：",
    "一次性防护服":"一次性防护服",
    "实验服":"实验服",
    "隔离衣":"隔离衣",
    "一次性防护口罩":"一次性防护口罩",
    "透气膜头套":"透气膜头套",
    "胡须套":"胡须套",
    "条帽":"条帽",    
    "袖套":"袖套",       
    "靴套":"靴套",       
    "鞋套":"鞋套",
    "PE塑料手套":"PE塑料手套" 
  }
}
</i18n>
